export default {"src":"/_next/static/image/public/images/ic_download_grey_round.f9a27dbcf5e99e8b633b46938d528eec.svg","height":52,"width":52};